// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"footer-module--site-footer--2SdSq","container":"footer-module--container--2Y5FL"};